/**
 * File Name          : formatters.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

export const variableSigFigsFormatter = (value: number | undefined): string => {
    if (value === undefined || isNaN(value) || value === null) {
        return ' - ';
    }
    if (value === 0) {
        return '0';
    }
    if(Math.abs(value) < 10) {
        return value.toFixed(2);
    }
    else if(Math.abs(value) < 100) {
        return value.toFixed(1);
    } else {
        return Math.round(value).toString();
    }
}